<script>
  import { Color } from '@client/components/color';
  import { Field, FieldActions, FieldHeader, FieldLabel, FieldValue } from '@client/components/fields/standalone/base';

  export let id = null;
  export let label = null;

  export let badge = undefined;
  export let tooltip = undefined;
  export let tooltipIcon = undefined;

  export let value = '';
  export let ref = null;
  export let formatValue = (val) => val || '-';

  export let disabled = null;
  export let editing = false;
  export let readonly = false;

  export let showActions = true;

  export let onChange = () => {};
  export let onUpdate = () => {};

  let color = value;
  let disableSubmit = true;
  let invalidColor = false;

  const onEdit = () => {
    editing = true;

    if (!color) {
      color = '#000000';
    }
  };

  const onCancel = () => {
    editing = false;
    color = value;
  };

  const onInput = (event) => {
    color = event.detail ?? event.target.value;
    onChange(id, label, value);
  };

  const onSave = () => {
    value = color;
    editing = false;

    if (onUpdate) {
      onUpdate(id, label, color);
    }
  };

  $: disableSubmit = value === color || invalidColor;
  $: bordered = color?.toLowerCase() === '#ffffff';
</script>

<Field bind:editing>
  <FieldHeader>
    <FieldLabel {label} {tooltipIcon} {tooltip} />
    <FieldActions bind:readonly bind:editing bind:disableSubmit {onSave} {onEdit} {onCancel} {badge} {showActions} />
  </FieldHeader>
  <FieldValue {showActions}>
    {#if editing}
      <Color bind:ref bind:value={color} on:input={onInput} bind:invalidColor {disabled} style="max-width: 14.5rem" />
    {:else if color}
      <span class="swatch" class:bordered style="background-color: {color};"></span>
      <span class="ms-1">{color}</span>
    {:else}
      {@html formatValue(color)}
    {/if}

    {#if !editing}
      <slot name="inline" />
    {/if}
  </FieldValue>
  {#if !editing}
    <slot />
  {/if}
</Field>

<style lang="scss" src="./color-picker.scss"></style>
